import React, { useRef, useState } from 'react'
import Invoice from '../../Invoice/Invoice';
import DownloadInvoice from '../../Invoice/DownloadInvoice';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SliderImage from "../../../../Assets/SFG.jpeg"
import { Spinner } from 'react-bootstrap';
import PageNotFound from '../../PageNotFound/PageNotFound';
import Dada from "../../../../Assets/Dada.png"
import Srim from "../../../../Assets/SriM.png"
import Tambe from "../../../../Assets/Tambe.png"
import SomethingWrong from '../../PageNotFound/SomethingWrong';
import Download from "../../../../Assets/invoicedownload.png";

const CourseCard = ({ handlerPayment, image, courseName, courseDescription, duration, purchaseStatus, btnClass, loader, courseIncludesLabel, coursePurchased, enrollNow, expertVideos, instructors, DurationLabel, invoiceLink, keyPoint, courseIncludes, instructorsDetails, apierror, apiLabelError, courseData }) => {

    const jsxContent = <Invoice />
    const sliderRef = useRef(null);
    const [autoplay, setAutoplay] = useState(true);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: false,
        // autoplaySpeed: 3000,
        easing: 'easeInOutQuad',
        beforeChange: (currentSlide, nextSlide) => {
            const isVideoSlide = checkIfVideoSlide(currentSlide); // Check if the current slide is a video slide
            if (isVideoSlide) {
                sliderRef.current.slickPause();
            }
        },
        afterChange: (currentSlide) => {
            const isVideoSlide = checkIfVideoSlide(currentSlide); // Check if the current slide is a video slide
            if (!isVideoSlide) {
                sliderRef.current.slickPlay();
            }
        },
        customPaging: function (i) {
            return (
                <div style={{ width: '10px', height: '10px', background: '#333', borderRadius: '50%' }}>

                </div>
            );
        },
    };

    const checkIfVideoSlide = (slideIndex) => {
        return slideIndex === 1 || slideIndex === 3;
    };

    const handleSlideClick = () => {
        sliderRef.current.slickNext();
    };

    // for color array
    const colors = ['#FF9A83', '#FFDEA9', '#2F9177', '#B1D3FC', '#FF9A83'];

    return (
        <>
            {
                loader ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                    <Spinner animation="border" role="status" >
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
                    : (
                        apierror || apiLabelError ? (
                            < SomethingWrong />

                        ) :

                            <>
                                <div className='mainContainer slider-wrapper' style={{ overflowY: 'scroll', height: '88vh' }}>
                                    <Slider ref={sliderRef} {...settings}>
                                        <div className='imageContainer mt-3' onClick={handleSlideClick}>
                                            <img src={SliderImage} alt='image' className="w-100" style={{ borderRadius: "20px" }} />
                                        </div>
                                        <div className='imageContainer mt-3' onClick={handleSlideClick}>
                                            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                                                <iframe
                                                    src="https://customer-bzo8e8xg81cat4dt.cloudflarestream.com/56057646d4aa36803451dfc1117ccabd/iframe?poster=https%3A%2F%2Fcustomer-bzo8e8xg81cat4dt.cloudflarestream.com%2F56057646d4aa36803451dfc1117ccabd%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                                                    loading="lazy"
                                                    style={{ border: 'none', position: 'absolute', top: '0', left: '0', height: '100%', width: '100%' }}
                                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                                                    allowfullscreen="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                        <div className='imageContainer mt-3' onClick={handleSlideClick}>
                                            <img src={SliderImage} alt='image' className="w-100" style={{ borderRadius: "20px" }} />
                                        </div>
                                        <div className='imageContainer mt-3' onClick={handleSlideClick}>
                                            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                                                <iframe
                                                    src="https://customer-bzo8e8xg81cat4dt.cloudflarestream.com/56057646d4aa36803451dfc1117ccabd/iframe?poster=https%3A%2F%2Fcustomer-bzo8e8xg81cat4dt.cloudflarestream.com%2F56057646d4aa36803451dfc1117ccabd%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                                                    loading="lazy"
                                                    style={{ border: 'none', position: 'absolute', top: '0', left: '0', height: '100%', width: '100%' }}
                                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                                                    allowfullscreen="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </Slider>

                                    <div className='eventContainer mt-5' >
                                        <h6 style={{ fontWeight: "600", fontSize: "18px", lineHeight: '21.6px' }}>
                                            {courseName}
                                        </h6>
                                        <p style={{ fontWeight: "400", fontSize: "14px", lineHeight: '20px' }}>{courseDescription}</p>
                                        <ul style={{ listStyleType: 'none', fontSize: '14px', paddingLeft: '0px' }}>
                                            {
                                                keyPoint && keyPoint?.map((ele) => (
                                                    <>
                                                        <li>{ele}</li>
                                                    </>
                                                ))
                                            }

                                        </ul>
                                    </div>

                                    <div>
                                        <p style={{ fontSize: "16px", fontWeight: 500, lineHeight: "19.2px" }}><b>{DurationLabel}</b> :  {duration}</p>
                                    </div>

                                    <div>
                                        <p style={{ fontSize: "18px", fontWeight: 500, lineHeight: "34px" }}>
                                            <b>{expertVideos}</b>
                                        </p>
                                        <div className='imagesContainer'>
                                            <div style={{
                                                position: 'relative',
                                                paddingTop: '56.25%',
                                            }}>
                                                <iframe
                                                    src="https://customer-bzo8e8xg81cat4dt.cloudflarestream.com/56057646d4aa36803451dfc1117ccabd/iframe?poster=https%3A%2F%2Fcustomer-bzo8e8xg81cat4dt.cloudflarestream.com%2F56057646d4aa36803451dfc1117ccabd%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                                                    loading="lazy"
                                                    style={{ border: 'none', position: 'absolute', top: '0', left: '25px', height: '60', width: '90' }}
                                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                                                    allowfullscreen="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p style={{ fontSize: "18px", fontWeight: 500, lineHeight: "34px" }}>
                                            <b>{courseIncludesLabel}</b>
                                        </p>

                                        <div className='text-center' style={{ fontSize: '16px', lineHeight: '22px', fontWeight: '500' }}>
                                            {
                                                courseIncludes && courseIncludes?.map((ele, index) => (

                                                    <>
                                                        <div
                                                            key={index}
                                                            className='mt-3'
                                                            style={{ borderRadius: '10px', backgroundColor: colors[index], padding: '12px' }}
                                                        >
                                                            {ele}
                                                        </div>
                                                    </>
                                                ))
                                            }

                                        </div>
                                    </div>

                                    <div className='mt-3 instructor-wrapper'>
                                        <p style={{ fontSize: "18px", fontWeight: 500, lineHeight: "34px" }}>
                                            <b>{instructors}</b>
                                        </p>

                                        <div style={{ display: "flex", justifyContent: "space-around", margin: "20px 0px 70px 0px" }}>
                                            {
                                                instructorsDetails && instructorsDetails.map((ele, index) => (
                                                    <>
                                                        <div className='images'>
                                                            <img src={ele?.image} alt="Sri M" />
                                                            <p style={{ fontSize: "15px", textAlign: "center" }}>{ele?.name}</p>
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </div>

                                    </div>

                                    <div className='d-flex justify-content-center my-4'
                                        style={{
                                            width: "90%", display: "flex", justifyContent: "center", marginTop: "30px", marginBottom: "40px",
                                            position: "fixed", bottom: 0, left: "20px"
                                        }}
                                    >
                                        <button
                                            onClick={() => handlerPayment()}
                                            className={btnClass}
                                            disabled={purchaseStatus}>
                                            {purchaseStatus === false ? enrollNow : coursePurchased}
                                        </button>
                                    </div>

                                    <div style={{ padding: '20px 0px', boxSizing: 'border-box' }}>
                                        {purchaseStatus && (
                                            <div className='mb-5'>
                                                <a
                                                    href={invoiceLink}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    download="Invoice.pdf"
                                                >
                                                    <div style={{ fontSize: '18px', fontWeight: '400', lineHeight: '20px', color: '#127E60', textDecoration: 'underline', textAlign: 'left' }}>
                                                        <img src={Download} style={{ width: '25px', height: '25px', objectFit: 'cover' }} alt="Download Icon" />
                                                        <span className='ms-2'>Download Invoice</span>
                                                    </div>
                                                </a>
                                            </div>

                                        )}
                                    </div>
                                    {/* <DownloadInvoice jsxContent={Invoice} purchaseStatus={purchaseStatus} invoiceLink={invoiceLink} /> */}

                                </div>

                            </>
                    )

            }

        </ >
    )
}

export default CourseCard
